<template>
  <div class="input-group">
    <label>{{label}}</label>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InputGroup',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.input-group {
  display: flex;
  margin-bottom: 2rem;

  input {
    flex: 1;
    padding: 0px;
    border: none;
    background: none;

    &:focus, &:active {
      outline: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// InputGroup.vue?5d9d8b21